export class FooterBannerController {
	constructor() {
		this.init();
	}

	init() {
		document.addEventListener('click', (e) => {
			if (e.target.closest('.footer-banner__close')) {
				e.target.closest('.footer-banner')?.classList.add('hidden');
			}

			if (e.target.closest('.open-support')) {
				const btn = e.target.closest('.open-support');
				if (btn.classList.contains('open-collaborate')) {
					this.openModal(document.querySelector('.collaborate-modal'));
				} else {
					this.openModal(document.querySelector('.support-modal'));
				}
			}

			if (e.target.classList.contains('rgba') || e.target.closest('.support-modal__exit')) {
				this.closeModal(document.querySelector('.support-modal'));
			}

			if (e.target.classList.contains('rgba') || e.target.closest('.collaborate-modal__exit')) {
				this.closeModal(document.querySelector('.collaborate-modal'));
			}
		});

		if (!window.jQuery) {
			return;
		}

		const $ = window.jQuery;

		// GP Reload Form auto-replaces confirmation after refreshTime (3s on prod).
		// Disable that for forms hosted inside support/collaborate modals.
		$(document).on('gform_post_render', (_event, formId) => {
			this.disableAutoReloadForModalForm(formId);
		});

		$(document).on('gform_confirmation_loaded', (_event, formId) => {
			this.handleConfirmation(formId);
		});

		// gwrf is created on post_render; catch instances that already exist on load.
		$(() => this.disableAutoReloadInModals());
		window.addEventListener('load', () => this.disableAutoReloadInModals());
	}

	openModal(modal) {
		if (!modal) {
			return;
		}
		modal.classList.add('open');
	}

	closeModal(modal) {
		if (!modal || !modal.classList.contains('open')) {
			return;
		}

		modal.classList.remove('open');
		this.resetModalTitles(modal);

		const formId = this.getFormId(modal);
		if (formId) {
			this.reloadForm(formId);
		}
	}

	handleConfirmation(formId) {
		const formIdNum = parseInt(formId, 10);
		if (!formIdNum) {
			return;
		}

		const modal = this.findOpenModalForForm(formIdNum);
		if (!modal) {
			return;
		}

		this.showSuccessTitle(modal);
		this.disableAutoReloadForModalForm(formIdNum);

		// GP may schedule its timeout after our handler; clear across a few ticks.
		[0, 10, 50, 100, 500, 1000, 2000, 3500].forEach((ms) => {
			setTimeout(() => this.cancelReload(formIdNum), ms);
		});
	}

	disableAutoReloadInModals() {
		document
			.querySelectorAll(
				'.support-modal [id^="gf_"], .support-modal [id^="gform_wrapper_"], .collaborate-modal [id^="gf_"], .collaborate-modal [id^="gform_wrapper_"]'
			)
			.forEach((node) => {
				const match = (node.id || '')
					.toString()
					.match(/(?:gform_wrapper_|gf_)(\d+)/);
				if (match) {
					this.disableAutoReloadForModalForm(parseInt(match[1], 10));
				}
			});
	}

	disableAutoReloadForModalForm(formId) {
		const formIdNum = parseInt(formId, 10);
		if (!formIdNum) {
			return;
		}

		const inModal = document.querySelector(
			`.support-modal #gf_${formIdNum}, .support-modal #gform_wrapper_${formIdNum}, .collaborate-modal #gf_${formIdNum}, .collaborate-modal #gform_wrapper_${formIdNum}`
		);
		if (!inModal) {
			return;
		}

		const instance = window[`gwrf_${formIdNum}`];
		if (!instance) {
			return;
		}

		// refreshTime <= 0 skips GP's auto-reload after confirmation.
		instance.refreshTime = 0;
		this.cancelReload(formIdNum);

		if (!instance.__icarModalReloadPatched) {
			const originalReload = instance.reloadForm?.bind(instance);
			instance.reloadForm = () => {
				const modalOpen = document.querySelector(
					`.support-modal.open, .collaborate-modal.open`
				);
				const showingConfirmation =
					modalOpen &&
					modalOpen.querySelector(
						`#gform_confirmation_wrapper_${formIdNum}, .gform_confirmation_message_${formIdNum}`
					);

				// Keep confirmation visible while the modal is open.
				if (showingConfirmation) {
					return;
				}

				return originalReload?.();
			};
			instance.__icarModalReloadPatched = true;
		}
	}

	findOpenModalForForm(formId) {
		const selectors = [
			`#gform_confirmation_wrapper_${formId}`,
			`.gform_confirmation_message_${formId}`,
			`#gform_wrapper_${formId}`,
			`#gf_${formId}`,
		];

		for (const modal of document.querySelectorAll('.support-modal.open, .collaborate-modal.open')) {
			if (selectors.some((sel) => modal.querySelector(sel))) {
				return modal;
			}
		}

		return null;
	}

	getFormId(modal) {
		const node = modal.querySelector(
			'[id^="gform_wrapper_"], [id^="gform_confirmation_wrapper_"], [class*="gform_confirmation_message_"], [id^="gf_"]'
		);
		if (!node) {
			return null;
		}

		const match = (node.id || node.className)
			.toString()
			.match(/(?:gform_wrapper_|gform_confirmation_wrapper_|gform_confirmation_message_|gf_)(\d+)/);
		return match ? parseInt(match[1], 10) : null;
	}

	cancelReload(formId) {
		const instance = window[`gwrf_${formId}`];
		if (!instance) {
			return;
		}

		instance.refreshTime = 0;
		if (instance.refreshTimeout) {
			clearTimeout(instance.refreshTimeout);
			instance.refreshTimeout = null;
		}
	}

	reloadForm(formId) {
		const instance = window[`gwrf_${formId}`];
		if (instance && typeof instance.reloadForm === 'function') {
			instance.reloadForm();
		}
	}

	showSuccessTitle(modal) {
		modal
			.querySelectorAll(
				'.support-modal__title:not(.success), .collaborate-modal__title:not(.success)'
			)
			.forEach((el) => {
				el.style.display = 'none';
			});
		modal
			.querySelectorAll('.support-modal__title.success, .collaborate-modal__title.success')
			.forEach((el) => {
				el.style.display = '';
			});
	}

	resetModalTitles(modal) {
		modal
			.querySelectorAll(
				'.support-modal__title:not(.success), .collaborate-modal__title:not(.success)'
			)
			.forEach((el) => {
				el.style.display = '';
			});
		modal
			.querySelectorAll('.support-modal__title.success, .collaborate-modal__title.success')
			.forEach((el) => {
				el.style.display = 'none';
			});
	}
}
